type Language = {
    label: string,
    code: string
};

export const EMAIL_NOTIFICATIONS_LANGUAGES: Language[] = [
    { label: 'Čeština: Czech Republic', code: 'cs-CZ' },
    { label: 'Dansk: Denmark', code: 'da-DK' },
    { label: 'Deutsch: Germany', code: 'de-DE' },
    { label: 'English: Australia', code: 'en-AU' },
    { label: 'English: Europe', code: 'en-EU' },
    { label: 'English: United Kingdom', code: 'en-GB' },
    { label: 'English: Hong Kong', code: 'en-HK' },
    { label: 'English: Singapore', code: 'en-SG' },
    { label: 'English: North America', code: 'en-US' },
    { label: 'Español: Spain', code: 'es-ES' },
    { label: 'Español: Mexico (Latin America)', code: 'es-MX' },
    { label: 'Suomi: Finland', code: 'fi-FI' },
    { label: 'Français: Canada', code: 'fr-CA' },
    { label: 'Français: France', code: 'fr-FR' },
    { label: 'Indian: India', code: 'en-IN' },
    { label: 'Indonesian: Indonesian', code: 'id-ID' },
    { label: 'Italiano: Italy', code: 'it-IT' },
    { label: '日本語: Japan', code: 'ja-JP' },
    { label: '한국어: Korea', code: 'ko-KR' },
    { label: 'Nederlands: Netherlands', code: 'nl-NL' },
    { label: 'Norsk: Norway', code: 'no-NO' },
    { label: 'Polski: Poland', code: 'pl-PL' },
    { label: 'Português: Brazil', code: 'pt-BR' },
    { label: 'Português: Portugal', code: 'pt-PT' },
    { label: 'Русский: Russian Federation', code: 'ru-RU' },
    { label: 'Svenska: Sweden', code: 'sv-SE' },
    { label: '简体中文: China', code: 'zh-CN' },
    { label: '繁體中文: Taiwan', code: 'zh-TW' },
    { label: '新加坡简体: Singapore', code: 'zh-SG' }
];

export const getLanguageName = (code: string): string => {
    return EMAIL_NOTIFICATIONS_LANGUAGES.find((language) => language.code === code)?.label!;
};
